/* Polyfill for custom event since we are not transpiling in this plugin */
(function () {
	if (typeof window.CustomEvent === "function") return false;
	function CustomEvent(event, params) {
		params = params || { bubbles: false, cancelable: false, detail: null };
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}
	CustomEvent.prototype = window.Event.prototype;
	window.CustomEvent = CustomEvent;
})();

(function ($) {
	jQuery(document).ready(function () {
		if (annyang) {
			// Let's define our first command. First the text we expect, and then the function it should call
			var commands = {
				'ride the lightning': function () {
					window.location.href = '/lightning-results/';
				},
				'show (me) new vehicles': function () {
					window.location.href = '/new-vehicles/';
				},
				'show (me) used vehicles': function () {
					window.location.href = '/used-vehicles/';
				},
				'schedule service': function () {
					window.location.href = '/schedule-service/';
				},
				'schedule a test drive': function () {
					window.location.href = '/schedule-test-drive/';
				},
				'show (me) *vehicles for less than *max_amount': function (vehicles, max_amount) {
					var slider = $('.our_price-slider').data('ionRangeSlider');
					slider.update({ to: max_amount });
					var event = new CustomEvent('setLightningSearchValue', { detail: {search: vehicles, type: 'voice' }})
					document.dispatchEvent(event);
				},
				'show (me) (a ) (an ) *vehicles': function (vehicles) {
					var event = new CustomEvent('setLightningSearchValue', { detail: {search: vehicles, type: 'voice' }})
					document.dispatchEvent(event)
				},
				'next page': function () {
					$('.results-pagination li:last a, .pagination li:last a').click();
				},
				'go back': function () {
					$('.results-pagination li:first a, .pagination li:first a').click();
				},
				'go to the top': function () {
					$('html, body').stop().animate({ scrollTop: 0 }, 500);
				},
				'go to the bottom': function () {
					$('html, body').stop().animate({ scrollTop: $(document).height() }, 500);
				},
				'reset (my) search': function () {
					var event = new CustomEvent('clearLightningSearch')
					document.dispatchEvent(event)
				},
				'play the best karaoke song': function () {
					var $iframe = $("<iframe>").attr("src", "https://www.youtube.com/embed/2NQIPVqLMUg?enablejsapi=1&autoplay=1").css({ "width": 1024, "height": 768 });
					$("#karaoke").append($iframe);
					document.getElementById('karaoke').show();
				}
			};

			$(document).on('lightningSearchRendered', function () {
				// Add our commands to annyang
				annyang.addCommands(commands);

				annyang.addCallback('start', function () {
					diVoiceCheckState();
				});

				annyang.addCallback('end', function () {
					diVoiceCheckState();
				});

				annyang.addCallback('error', function (e) {
					diVoiceCheckState();
				});

				annyang.addCallback('errorNetwork', function (e) {
					diVoiceCheckState();
				});

				annyang.addCallback('errorPermissionBlocked', function () {
					annyang.abort();
					diVoiceCheckState();
				});

				annyang.addCallback('errorPermissionDenied', function () {
					annyang.abort();
					diVoiceCheckState();
				});

				annyang.addCallback('result', function (phrases) {
					console.log(phrases);
				});

				initDIVoice($);
			})

		} else {
			console.log('Voice failed');
		}
	}(jQuery));

	function diVoiceCheckState() {
		if (annyang.isListening()) {
			$('.search-input').attr('placeholder', divoice.listening_placeholder_text);
			$('.di-voice-mic').removeClass('listening-inactive').addClass('listening-active');
		} else {
			$('.search-input').attr('placeholder', divoice.notlistening_placeholder_text);
			$('.di-voice-mic').removeClass('listening-active').addClass('listening-inactive');
		}
	}

	function initDIVoice($) {

		$('.search-wrap, #mobile-search-field').addClass('voice-active');
		$('.search-wrap').prepend('<a href="#" class="di-voice-float"><svg title="Click to toggle on voice search" class="di-voice-mic" height="36" viewBox="0 0 24 24" width="36" xmlns="http://www.w3.org/2000/svg"> \
	  <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" /> \
	</svg></a>');
		$('#mobile-search-field').prepend('<a href="#" class="di-voice-float"><svg title="Click to toggle on voice search" class="di-voice-mic" height="28" viewBox="0 0 24 24" width="28" xmlns="http://www.w3.org/2000/svg"> \
	  <path d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z" /> \
	</svg></a>');

		var enabled = sessionStorage.getItem('di-voice-enabled');
		if (enabled === 'true') {
			annyang.start();
		}

		diVoiceCheckState();

		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				document.getElementById('karaoke').close();
				$('#karaoke').empty();
			}
		});

		$('.search-wrap .di-voice-float, #mobile-search-field .di-voice-float').click(function (e) {
			e.preventDefault();
			
			if ($(this).children('.di-voice-mic').hasClass('listening-active')) {
				sessionStorage.setItem('di-voice-enabled', 'false');
				annyang.abort();
			} else {
				sessionStorage.setItem('di-voice-enabled', 'true');
				annyang.start();
			}

			diVoiceCheckState();
		});
	}
}(jQuery))
